<template>
  <div class="grid">
    <div
      v-for="(value, index) in dados"
      class="grupo"
      @click="open(value.titulo, value.textoConteudo)"
      :key="index"
      :data-key="index"
    >
      <div class="imagem-conteudo">
        <img
          class="grid-img"
          alt="img"
          :src="value.imagem"
        />
        <div class="rodape-conteudo">
          <span class="rodape-conteudo__title">{{value.titulo}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'beneficiario-grid',
  props: {
    dados: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    open(titulo, texto) {
      this.$emit('open', { titulo, texto });
    },
  },

};
</script>

<style lang="scss" scoped>
</style>
